import React from 'react'
import { USER_SEARCH_PARAM } from '../../../../../constants/query-params'
import SearchInput from '../../../../../components/common/search-input/SearchInput'

const UserSearchInput = () => {
    return (
        <SearchInput
            placeholder='Search by name or email'
            aria-label='Search by name or email'
            searchParam={USER_SEARCH_PARAM}
        />
    )
}

export default UserSearchInput
